import { Typography } from "@/components/shared/typography";
import { View } from "@/components/ui";
import { NotificationSettings } from "@/containers/notifications/notification-settings";
// import { Link } from "@/components/shared/link";
// import { ArrowLeft } from "@/components/shared/icons";
import { Divider } from "@/components/shared/divider";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { IconButton } from "@/components/ui/icon-button/index.web";
import { useRoute } from "@/components/shared/router";

export function NotificationSettingsPage() {
  const { isMobile } = useWindowDimensions();
  const { push } = useRoute();
  return (
    <View>
      <View className="flex flex-row items-center gap-2 p-4 md:mb-4 md:p-0">
        {/* {isMobile && (
          <Link href="/profile">
            <ArrowLeft className="size-5" />
          </Link>
        )} */}
        <IconButton
          variant={isMobile ? "ghost" : "secondary"}
          color="foreground"
          iconName="arrowLeft"
          rounded="full"
          className="p-0 md:hidden md:px-3 md:py-2"
          onClick={() => push({ pageKey: "profile" })}
        />
        <Typography variant="label-md">Notification Settings</Typography>
      </View>
      <Divider />
      <NotificationSettings />
    </View>
  );
}
